var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.849511 0C0.202511 0 -0.176739 0.728766 0.193261 1.25977L6.18154 9.81836L0.169824 16.8457C-0.219176 17.2997 0.103074 18 0.701074 18H1.36514C1.65814 18 1.93685 17.8714 2.12685 17.6484L7.36514 11.5117L11.3085 17.1465C11.6835 17.6805 12.2952 18 12.9472 18H16.2812C16.9282 18 17.3074 17.2722 16.9374 16.7422L10.619 7.69922L16.3456 0.990234C16.6776 0.600234 16.4006 0 15.8886 0H15.0429C14.7509 0 14.4731 0.127609 14.2831 0.349609L9.44131 6.00977L5.83975 0.855469C5.46575 0.319469 4.85507 0 4.20107 0H0.849511Z",
    fill: "url(#paint0_linear_1773_21137)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1773_21137",
    x1: 0,
    y1: 9,
    x2: 17.0827,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.7944afc2a89643938ebade3fffa40a73.svg";
export { ForwardRef as ReactComponent };